<template>
  <div>
    <div class="riTop">
      <img src="@/assets/image/ico7.svg">
      <!--      <img src="@/assets/image/ico8.svg">-->
      <!--      <span @click="openDatePicker">日</span>-->
      <!--      <el-date-picker-->
      <!--        ref="datePicker"-->
      <!--        v-model="pickedDate"-->
      <!--        type="date"-->
      <!--        placeholder=""-->
      <!--        value-format="yyyy-MM-dd"-->
      <!--        style="width: 5px; visibility: hidden"-->
      <!--      />-->
    </div>
    <div style="display: flex;align-items: stretch;gap: 20px;margin-top: 20px;flex-wrap: wrap">
      <div class="card">
        <span>院内餐數</span>
        <div class="cardTop">
          <div @click="setcanType('first')">
            <img src="@/assets/image/y1.svg">
            <p>早餐</p>
            <i></i>
            <h2>{{ todayObj.in_agency ? todayObj.in_agency[1] : "" }}</h2>
            <span>今日訂餐數量</span>
          </div>
          <div @click="setcanType('first')">
            <img src="@/assets/image/y2.svg">
            <p>午餐</p>
            <i></i>
            <h2>{{ todayObj.in_agency ? todayObj.in_agency[2] : "" }}</h2>
            <span>今日訂餐數量</span>
          </div>
          <div @click="setcanType('first')">
            <img src="@/assets/image/y3.svg">
            <p>晚餐</p>
            <i></i>
            <h2>{{ todayObj.in_agency ? todayObj.in_agency[3] : "" }}</h2>
            <span>今日訂餐數量</span>
          </div>
        </div>
        <div class="cardToptwo">
          <div class="top" @click="setcanType('second')">
            <p>
              <img src="@/assets/image/ico13.svg">
              試吃</p>
            <i></i>
            <div class="bott">
              <div>
                <h2>{{ todayObj.mold_3 ? todayObj.mold_3[1] : "" }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_3 ? todayObj.mold_3[2] : "" }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_3 ? todayObj.mold_3[3] : "" }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
          <div class="top" @click="setcanType('fourth')">
            <p>
              <img src="@/assets/image/ico15.svg">
              陪宿</p>
            <i></i>
            <div class="bott">
              <div>
                <h2>{{ todayObj.mold_4 ? todayObj.mold_4[1] : "" }}</h2>
                <span>早餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_4 ? todayObj.mold_4[2] : "" }}</h2>
                <span>午餐</span>
              </div>
              <div>
                <h2>{{ todayObj.mold_4 ? todayObj.mold_4[3] : "" }}</h2>
                <span>晚餐</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card cardtwo">
        <span>院外餐數</span>
        <div class="cardbody" @click="setcanType('third')">
          <div>
            <img src="@/assets/image/y4.svg" />
            <p>早餐</p>
          </div>
          <div>
            <h2>{{ todayObj.mold_2 ? todayObj.mold_2[1] : "" }}</h2>
            <span>今日訂餐數量</span>
          </div>
        </div>
        <div class="cardbody" @click="setcanType('third')">
          <div>
            <img src="@/assets/image/y5.svg" />
            <p>午餐</p>
          </div>
          <div>
            <h2>{{ todayObj.mold_2 ? todayObj.mold_2[2] : "" }}</h2>
            <span>今日訂餐數量</span>
          </div>
        </div>
        <div class="cardbody" @click="setcanType('third')">
          <div>
            <img src="@/assets/image/y6.svg" />
            <p>晚餐</p>
          </div>
          <div>
            <h2>{{ todayObj.mold_2 ? todayObj.mold_2[3] : "" }}</h2>
            <span>今日訂餐數量</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { todayOrderCount } from "@/api";

export default {
  data() {
    return {
      todayObj: {}
    };
  },
  mounted() {
    this.todayOrderCount();
  },
  methods: {
    todayOrderCount() {
      todayOrderCount().then(res => {
        this.todayObj = res.data.list;
      });
    },
    setcanType(type) {
      this.$emit("done", type);
    }
  }
};

</script>


<style scoped lang="scss">
.riTop {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
  cursor: pointer;

  span {
    font-size: 12px;
    color: #DBBD80;
    padding: 0px 6px;
    border: 1px solid #DBBD80;
    border-radius: 5px;
    border-top-width: 8px;
  }

  img {
    width: 26px;
    height: 26px;
    object-fit: contain;
  }
}

.card {
  flex: 2;
  background: #FFFFFF;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 10px 20px;

  span:first-child {
    font-size: 22px;
    display: block;
    text-align: start;
    border-left: 5px solid #DBBD80;
    padding: 0px 10px;
    color: #DBBD80;
  }

  .cardTop {
    display: flex;
    align-items: stretch;
    margin-top: 10px;
    gap: 20px;
    margin-top: 20px;

    div {
      flex: 1;
      letter-spacing: 2px;
      cursor: pointer;

      img {
        width: 100px;
        height: 100px;
        object-fit: contain;
      }

      border: 1px solid #FFFFFF;
      border-radius: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 50px;

      i {
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #DBBD80;
      }

      h2 {
        color: #DBBD80;
        font-size: 60px;
        margin: 10px;

      }

      p {
        font-size: 20px;
        margin-bottom: 0;
      }

      span {
        color: #b6b8bd;
      }

    }
  }

  .cardToptwo {
    margin-top: 20px;
    display: flex;
    gap: 20px;

    .top {
      cursor: pointer;
      flex: 1;
      letter-spacing: 2px;
      border: 1px solid #FFFFFF;
      border-radius: 15px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 50px;

      p {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;

        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          margin-right: 30px;
        }
      }

      i {
        display: inline-block;
        width: 30px;
        height: 3px;
        background: #DBBD80;
      }

      .bott {
        display: flex;
        justify-content: center;

        div {
          flex: 1;

          h2 {
            font-size: 60px;
            color: #DBBD80;
            margin: 10px;
          }

          span {
            color: #b6b8bd;
          }
        }
      }
    }
  }
}

.cardtwo {
  flex: 1;

  .cardbody {
    cursor: pointer;
    background: #FFFFFF;
    border-radius: 15px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 45px 20px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 2px;

    div:first-child {
      padding-right: 20px;
      margin-right: 50px;
    }

    img {
      width: 100px;
      height: 100px;
      object-fit: contain;
      margin-right: 50px;
    }

    p {
      font-size: 20px;
      margin: 0;
      padding-right: 20px;
      border-right: 3px solid #DBBD80;
    }

    h2 {
      font-size: 60px;
      color: #DBBD80;
      margin: 10px;
    }

    span {
      color: #b6b8bd;
    }
  }
}
</style>
